import {
  Box,
  Container,
  Divider,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import Logo from "../../general/Logo";
import { footerCopy } from "../../../pages/website/content/homeCopy";

const Footer = () => (
  <Box
    component="footer"
    sx={{
      backgroundColor: "background.default",
      py: { xs: 6, md: 8 },
    }}
  >
    <Container maxWidth="lg">
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 4, sm: 0 }}
        justifyContent={{ xs: "center", sm: "space-between" }}
        alignItems={{ xs: "center", sm: "flex-start" }}
        sx={{ width: "100%", px: { sm: 18 } }}
      >
          {/* Company */}
          <Stack spacing={1} alignItems={{ xs: "center", sm: "flex-start" }}>
            <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
              {footerCopy.company.title}
            </Typography>
            {footerCopy.company.links.map(({ label, href }) => (
              <Link
                key={href}
                href={href}
                color="text.secondary"
                underline="hover"
                variant="body2"
              >
                {label}
              </Link>
            ))}
          </Stack>

          {/* Legal */}
          <Stack spacing={1} alignItems={{ xs: "center", sm: "flex-start" }}>
            <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
              {footerCopy.legal.title}
            </Typography>
            {footerCopy.legal.links.map(({ label, href }) => (
              <Link
                key={href}
                href={href}
                color="text.secondary"
                underline="hover"
                variant="body2"
              >
                {label}
              </Link>
            ))}
          </Stack>

          {/* Connect */}
          <Stack spacing={1} alignItems={{ xs: "center", sm: "flex-start" }}>
            <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
              {footerCopy.connect.title}
            </Typography>
            <Link
              href={footerCopy.connect.linkedInUrl}
              target="_blank"
              rel="noopener noreferrer"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              LinkedIn
            </Link>
          </Stack>
      </Stack>

      <Divider sx={{ my: 4 }} />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        alignItems={{ xs: "center", sm: "center" }}
        justifyContent="space-between"
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: { xs: "center", sm: "left" } }}
        >
          {footerCopy.copyright}
        </Typography>
        <Logo size={30} to="/" />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: { xs: "center", sm: "right" } }}
        >
          {footerCopy.registration}
        </Typography>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
